<div class="card">
    <div class="card-header card-header-squirrel">
        <h4>Projekt löschen</h4>
        <!-- <h4>{{this.translate.data['TOOLTIPREMOVEUSER'] | translate}}</h4> -->
    </div>

    <div class="card-body">
        <form [formGroup]="projectForm">
            <mat-form-field class="example-full-width" style="width: 0; height: 0;">
                <input matInput hidden formControlName="id" readonly>
            </mat-form-field>
    
            <mat-form-field class="example-full-width">
                <input matInput formControlName="name" readonly>
                <!-- <button mat-button color="primary"  matSuffix mat-icon-button (click)="deleteUser(userDto.id)"> 
                    <mat-icon>delete</mat-icon>
                </button> -->
            </mat-form-field>
            <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px" matTooltip="Dialog schließen"
                (click)="cancel()" >Abbruch</button>
                <button  mat-raised-button class="btn btn-squirrel pull-right" (click)="deleteProject()" color="primary">Entfernen</button>
                <!-- <button  mat-raised-button class="btn btn-squirrel pull-right" (click)="deleteUser(userDto.id)" color="primary">Entfernen</button> -->
            </form>
    </div>
</div>